export const unAccent = (input?: any): string => {
  if (!input) return '';

  return `${input}`.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
